import { UserSettingsKeys } from "constants/user-settings-keys";
import { UserDashboardPublicationTab } from "models/enumerations/user-dashboard/user-dashboard-publication-tab";
import { ViewModes } from "models/enumerations/view-modes/view-modes";
import { useGlobalState } from "utilities/contexts/use-global-state-context";
import useUserSettings from "utilities/hooks/domain/user-settings/use-user-settings";

export const useUserDashboardPreferences = () => {
    const { createOrUpdate } = useUserSettings();
    const { globalState, setGlobalState } = useGlobalState();

    const updateOrCreateUserDashboardUserSetting = async (
        key: keyof typeof UserSettingsKeys,
        value: string | number
    ) => {
        const setting = globalState.getUserSetting(key);
        try {
            const response = await createOrUpdate(
                setting?.with({ value: value.toString() }),
                globalState.currentIdentity?.userId()!
            );
            if (!response) {
                throw new Error();
            }
            setGlobalState((prevGlobalState) =>
                prevGlobalState.updateUserSetting(response)
            );
        } catch (error) {
            console.error(error);
        }
    };

    const defaultPublicationsTab =
        globalState.getUserSettingValue<UserDashboardPublicationTab>(
            UserSettingsKeys.SelectedUserDashboardPublicationTab as keyof typeof UserSettingsKeys
        ) ?? UserDashboardPublicationTab.Favorites;

    const setDefaultPublicationsTab = async (newValue) =>
        await updateOrCreateUserDashboardUserSetting(
            "SelectedUserDashboardPublicationTab",
            newValue
        );

    const defaultPublicationsView =
        globalState.getUserSettingValue<ViewModes>(
            UserSettingsKeys.SelectedUserDashboardPublicationView as keyof typeof UserSettingsKeys
        ) ?? ViewModes.Grid;

    const setDefaultPublicationsView = async (newValue) => {
        await updateOrCreateUserDashboardUserSetting(
            "SelectedUserDashboardPublicationView",
            newValue
        );
    };

    return {
        defaultPublicationsTab,
        setDefaultPublicationsTab,
        defaultPublicationsView,
        setDefaultPublicationsView,
    };
};
